var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "k-pagination-footer",
      attrs: { "grid-list-xs": "", fluid: "", "align-center": "" }
    },
    [
      _c(
        "v-layout",
        { style: { alignItems: "center" }, attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs4: "" } },
            [
              _c("span", [_vm._v("Rows Per Page:")]),
              _vm._v(" "),
              _c("pagination-options", {
                ref: "pagination-options",
                attrs: {
                  "total-items-count": _vm.totalItemsCount,
                  "filtered-items-count": _vm.filteredItemsCount,
                  "is-server-side": _vm.isServerSide,
                  disabled: _vm.disabled
                },
                on: { "set-page-size": _vm.setPageSize }
              }),
              _vm._v(" "),
              _vm.selectedItemsCount > 0
                ? _c("span", { staticClass: "ml-1" }, [
                    _c("em", [
                      _vm._v(_vm._s(_vm.selectedItemsCount) + " Row"),
                      _vm.selectedItemsCount > 1
                        ? _c("span", [_vm._v("s")])
                        : _vm._e(),
                      _vm._v("\n          Selected")
                    ])
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "k-page-nav-ctrls", attrs: { xs4: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    flat: "",
                    icon: "",
                    color: "link",
                    disabled: _vm.isOnFirstPage
                  },
                  on: { mousedown: _vm.handleFirstPageNavClick }
                },
                [_c("v-icon", [_vm._v("skip_previous")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    flat: "",
                    icon: "",
                    color: "link",
                    disabled: _vm.isOnFirstPage
                  },
                  on: { mousedown: _vm.handlePrevPageNavClick }
                },
                [_c("v-icon", { attrs: { size: 31 } }, [_vm._v("arrow_left")])],
                1
              ),
              _vm._v(" "),
              _c("span", { style: { padding: "0 8px" } }, [
                _vm._v(_vm._s(_vm.currPage))
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    flat: "",
                    icon: "",
                    color: "link",
                    disabled: _vm.isOnLastPage
                  },
                  on: { mousedown: _vm.handleNextPageNavClick }
                },
                [
                  _c("v-icon", { attrs: { size: 31 } }, [_vm._v("arrow_right")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    flat: "",
                    icon: "",
                    color: "link",
                    disabled: _vm.isOnLastPage
                  },
                  on: { mousedown: _vm.handleLastPageNavClick }
                },
                [_c("v-icon", [_vm._v("skip_next")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { staticClass: "text-xs-right", attrs: { xs4: "" } }, [
            _vm._v("\n      " + _vm._s(_vm.showingAmount) + "\n      "),
            _vm.hasFilters
              ? _c("span", [
                  _vm._v("(filtered from " + _vm._s(_vm.totalItemsCount) + ")")
                ])
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }